import { Outlet } from 'react-router-dom';
import PortalHeader from '../components/portal/PortalHeader';
import PortalFooter from '../components/portal/PortalFooter';

export default function ZehumaPortalLayout() {
    return (
        <div className="min-h-screen flex flex-col bg-gradient-to-b from-slate-50 via-white to-slate-50 text-slate-900">
            <PortalHeader />
            <main className="flex-1">
                <Outlet />
            </main>
            <PortalFooter />
        </div>
    );
}
